import api from './api';
export { default as authService } from './authService';

export const planesService = {
  getAll: async () => {
    const response = await api.get('/planes');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/planes/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await api.post('/planes', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await api.put(`/planes/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/planes/${id}`);
    return response.data;
  }
};

export const suscripcionesService = {
  getMiPlan: async () => {
    const response = await api.get('/suscripciones/mi-plan');
    return response.data;
  },
  
  getAll: async () => {
    const response = await api.get('/suscripciones');
    return response.data;
  },
  
  create: async (data) => {
    const response = await api.post('/suscripciones', data);
    return response.data;
  },
  
  cancelar: async (id) => {
    const response = await api.post(`/suscripciones/${id}/cancelar`);
    return response.data;
  }
};

export const pagosService = {
  getAll: async (params = {}) => {
    const response = await api.get('/pagos', { params });
    return response.data;
  },
  
  registrar: async (data) => {
    const response = await api.post('/pagos', data);
    return response.data;
  },
  
  confirmar: async (id, observaciones) => {
    const response = await api.put(`/pagos/${id}/confirmar`, { observaciones });
    return response.data;
  },
  
  rechazar: async (id, motivo) => {
    const response = await api.put(`/pagos/${id}/rechazar`, { motivo });
    return response.data;
  }
};

export const dashboardService = {
  getEstadisticas: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },
  
  getReporteIngresos: async (periodo, fechaInicio, fechaFin) => {
    const response = await api.get('/dashboard/ingresos', {
      params: { periodo, fechaInicio, fechaFin }
    });
    return response.data;
  },
  
  getReporteAsistencia: async () => {
    const response = await api.get('/dashboard/asistencia');
    return response.data;
  },
  
  getReporteOcupacion: async () => {
    const response = await api.get('/dashboard/ocupacion');
    return response.data;
  }
};

export const usuariosService = {
  getAll: async (params) => {
    const response = await api.get('/usuarios', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/usuarios/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await api.post('/usuarios', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await api.put(`/usuarios/${id}`, data);
    return response.data;
  },
  
  toggleActivo: async (id) => {
    const response = await api.patch(`/usuarios/${id}/toggle-activo`);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/usuarios/${id}`);
    return response.data;
  }
};

export const bloquesService = {
  getAll: async (params) => {
    const response = await api.get('/bloques', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/bloques/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await api.post('/bloques', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await api.put(`/bloques/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/bloques/${id}`);
    return response.data;
  }
};

export const sesionesService = {
  getMisSesiones: async () => {
    const response = await api.get('/sesiones/mis-sesiones');
    return response.data;
  },
  
  getAll: async (params) => {
    const response = await api.get('/sesiones', { params });
    return response.data;
  },
  
  getByClienteId: async (clienteId) => {
    const response = await api.get(`/sesiones/cliente/${clienteId}`);
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/sesiones/${id}`);
    return response.data;
  },
  
  reservar: async (bloqueHorarioId) => {
    const response = await api.post('/sesiones/reservar', { bloqueHorarioId });
    return response.data;
  },
  
  cancelar: async (id, motivo) => {
    const response = await api.post(`/sesiones/${id}/cancelar`, { motivo });
    return response.data;
  },
  
  confirmar: async (id) => {
    const response = await api.post(`/sesiones/${id}/confirmar`);
    return response.data;
  }
};

export const ejerciciosService = {
  getAll: async (params) => {
    const response = await api.get('/ejercicios', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/ejercicios/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await api.post('/ejercicios', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await api.put(`/ejercicios/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/ejercicios/${id}`);
    return response.data;
  }
};

export const rutinasService = {
  getAll: async (params) => {
    const response = await api.get('/rutinas', { params });
    return response.data;
  },

  getByClienteId: async (clienteId) => {
    const response = await api.get(`/rutinas/cliente/${clienteId}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/rutinas/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/rutinas', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/rutinas/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/rutinas/${id}`);
    return response.data;
  },

  clonar: async (id) => {
    const response = await api.post(`/rutinas/${id}/clonar`);
    return response.data;
  },
};

export const planificacionesService = {
  getMisPlanificaciones: async () => {
    const response = await api.get('/planificaciones/mis-planificaciones');
    return response.data;
  },
  
  getByClienteId: async (clienteId) => {
    const response = await api.get(`/planificaciones/cliente/${clienteId}`);
    return response.data;
  },
  
  getAll: async (params) => {
    const response = await api.get('/planificaciones', { params });
    return response.data;
  },
  
  create: async (data) => {
    const response = await api.post('/planificaciones', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await api.put(`/planificaciones/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/planificaciones/${id}`);
    return response.data;
  },
  
  getHistorialCambios: async (id) => {
    const response = await api.get(`/planificaciones/${id}/historial-cambios`);
    return response.data;
  }
};
